import type { CurvesFormState } from "../../types";

/**
 * Gets the primary provider from search params or returns default value
 *
 * ## Why do we use "DP_1" as default?
 * - "DP_1" is the codename for the most used provider.
 * - We cannot use the actual name of the provider for legal reasons.
 * - `Sonia Lopez` is the person of contact for this.
 *
 * @param {URLSearchParams} searchParams - URL search parameters
 * @returns {CurvesFormState["primaryDataProvider"]} Primary provider value is "DP_1" by default.
 */
export const getPrimaryDataProvider = (searchParams: URLSearchParams): CurvesFormState["primaryDataProvider"] => {
  return (searchParams.get("primaryDataProvider") as CurvesFormState["primaryDataProvider"] | null) ?? "DP_1";
};
